var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Content as MenuListRoot } from '@radix-ui/react-dropdown-menu';
import { node, number, oneOf } from 'prop-types';
import Box from '../../Box';
var StyledMenuList = styled(MenuListRoot)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  ", "\n"])), function (_ref) {
  var _ref$theme$yoga = _ref.theme.yoga,
      menu = _ref$theme$yoga.components.menu,
      elevations = _ref$theme$yoga.elevations;
  return "\n    margin: " + menu.margin["default"] + "px 0;\n    padding: 0;\n    min-width: " + menu.width.min + "px;\n    max-width: " + menu.width.max + "px;\n    border-radius: " + menu.border.radius + "px;\n\n    background-color: " + menu.backgroundColor.white + ";\n    box-shadow: " + elevations.small + "\n  ";
});
var MenuList = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      align = _ref2.align,
      alignOffset = _ref2.alignOffset,
      side = _ref2.side,
      sideOffset = _ref2.sideOffset;
  return /*#__PURE__*/React.createElement(StyledMenuList, {
    asChild: true,
    side: side,
    sideOffset: sideOffset,
    align: align,
    alignOffset: alignOffset
  }, /*#__PURE__*/React.createElement(Box, {
    as: "ul",
    m: "zero",
    ref: ref
  }, children));
});
MenuList.propTypes = {
  /** Component to be rendered inside the Menu.List container */
  children: node.isRequired,

  /** Setup the vertical placement relative to Menu.Action component */
  align: oneOf(['start', 'center', 'end']),

  /** Add vertical space between the Menu.Action and the Menu.List */
  alignOffset: number,

  /** Setup the horizontal placement relative to Menu.Action component */
  side: oneOf(['top', 'right', 'bottom', 'left']),

  /** Add horizontal space between the Menu.Action and the Menu.List */
  sideOffset: number
};
MenuList.defaultProps = {
  align: 'start',
  alignOffset: 0,
  side: 'bottom',
  sideOffset: 4
};
MenuList.displayName = 'Menu.List';
export default MenuList;